import { faGavel } from '@fortawesome/pro-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import type { IHeaderParams } from 'ag-grid-community'

import { useActionPanel } from '../ActionPanelProvider'
import { ActionPanelToggle } from '../ActionPanelToggle'
import { getActionFormWidth } from '../getActionPanelWidth'
import { Header, FormHalf, HeaderLabel, MenuHalf } from './ui'

/**
 * "My Max Bid" becomes "Action" in the ActionPanel UX.
 *
 * Gavel and label shown in `wide` variant; the chevron shows in both
 * rendered variants. `minimized` has no header at all — the column is hidden,
 * and `MinimizedPanelOverlay` is shown, instead.
 */
export const ActionColumnHeader = ({ displayName }: IHeaderParams) => {
  const { isExpanded, setIsExpanded, variant } = useActionPanel()
  if (variant === 'minimized') return null

  return (
    <Header $formWidth={getActionFormWidth(variant)}>
      <FormHalf>
        {variant === 'wide' && (
          <>
            <FontAwesomeIcon icon={faGavel} />
            <HeaderLabel>{displayName}</HeaderLabel>
          </>
        )}
      </FormHalf>
      <MenuHalf>
        <ActionPanelToggle
          isExpanded={isExpanded}
          setIsExpanded={setIsExpanded}
        />
      </MenuHalf>
    </Header>
  )
}
